import styled from 'styled-components';
import React, { useContext, useState } from 'react';
import { ConnectedAccountContext } from '@/contexts';
import { PageTile, HeaderText, Button, FlexRow } from '@make-software/cspr-design';

import { BuyStampsModal, StampActivityTable, Container } from '@/components';

import { useGetStampHistoryForAccount } from '@/hooks';

const PageContentSection = styled.section(({ theme }) =>
  theme.withMedia({
    maxWidth: ['100%', '720px', '1200px'],
    width: '100%',
    margin: '0 auto',
    padding: '0 12px',
    paddingTop: '48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  })
);

const HeaderRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  })
);

const HeaderButton = styled(Button)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer',
    width: '176px',
    height: '36px',
  })
);

const StampsScene = () => {
  const [showBuyStampsModal, setShowBuyStampsModal] = useState<boolean>(false);
  const { connectedAccount } = useContext(ConnectedAccountContext);

  if (!connectedAccount) {
    return null;
  }

  return (
    <Container>
      <PageContentSection>
        <HeaderRow>
          <HeaderText size={2}>History</HeaderText>
          <HeaderButton onClick={() => setShowBuyStampsModal(true)}>
            Buy Stamps
          </HeaderButton>
        </HeaderRow>

        <PageTile>
          <StampActivityTable dataLoader={(page: number, perPage: number) =>
            useGetStampHistoryForAccount(connectedAccount.public_key, page, perPage)
          } />
        </PageTile>

        <BuyStampsModal
          isOpen={showBuyStampsModal}
          onClose={() => setShowBuyStampsModal(false)}
        />
      </PageContentSection>
    </Container>
  );
};

export default StampsScene;
